<template>
  <div class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <MerchantOperators></MerchantOperators>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import MerchantOperators from "@/components/users/MerchantOperators.vue";

export default defineComponent({
  components: {
    MerchantOperators,
  },
})
</script>